import { settingValue } from './settingsFields.js'

export const AUDIO_DEVICE_FIELDS = [
  { key: 'inputPhone', kind: 'audioinput', label: 'Microfone', feminine: false },
  { key: 'outputPhone', kind: 'audiooutput', label: 'Saída de áudio', feminine: true },
  { key: 'additionalDevice', kind: 'audiooutput', label: 'Campainha', feminine: true }
]

// Without mic permission the browser lists devices with empty ids
const hasHiddenDevices = (devices) => devices.some(({ kind, deviceId }) => kind === 'audioinput' && !deviceId)

const requestMicPermission = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    stream.getTracks().forEach((track) => track.stop())
    return true
  } catch (error) {
    return error?.name !== 'NotAllowedError'
  }
}

export const listAudioDevices = async () => {
  let devices = await navigator.mediaDevices.enumerateDevices()
  let micDenied = false

  if (hasHiddenDevices(devices)) {
    micDenied = !(await requestMicPermission())
    devices = await navigator.mediaDevices.enumerateDevices()
  }

  const byKind = (deviceKind) => devices
    .filter(({ kind, deviceId }) => kind === deviceKind && deviceId)
    .map(({ label, deviceId: id }) => ({ id, label }))

  return { audioinput: byKind('audioinput'), audiooutput: byKind('audiooutput'), micDenied }
}

export const findMissingAudioDevices = (settings, devices) => (
  AUDIO_DEVICE_FIELDS.filter(({ key, kind }) => (
    !devices[kind].some(({ id }) => id === settingValue(settings, key))
  ))
)

export const onAudioDevicesChange = (handler) => {
  let permission = null
  let stopped = false
  navigator.mediaDevices.addEventListener('devicechange', handler)

  navigator.permissions?.query({ name: 'microphone' })
    .then((status) => {
      if (stopped) return
      permission = status
      permission.addEventListener('change', handler)
    })
    .catch(() => {})

  return () => {
    stopped = true
    navigator.mediaDevices.removeEventListener('devicechange', handler)
    permission?.removeEventListener('change', handler)
  }
}

let knownDevices = null
let watching = false

const refreshKnownDevices = async () => {
  try {
    knownDevices = await listAudioDevices()
  } catch {
    knownDevices = null
  }
}

export const watchAudioDevices = () => {
  if (watching) return
  watching = true
  refreshKnownDevices()
  onAudioDevicesChange(refreshKnownDevices)
}

// Sem listagem ainda não bloqueia: na dúvida, deixa a chamada seguir
export const isMicAvailable = (settings) => (
  !knownDevices || knownDevices.audioinput.some(({ id }) => id === settingValue(settings, 'inputPhone'))
)

export const isMicDenied = () => Boolean(knownDevices?.micDenied)
